import { downloadLinks } from '@/mocks/about';

export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="bg-primary-500 rounded-2xl p-10 md:p-16 relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute -top-20 -right-20 w-64 h-64 bg-background-50 rounded-full"></div>
            <div className="absolute -bottom-20 -left-20 w-80 h-80 bg-accent-500 rounded-full"></div>
          </div>
          <div className="relative z-10">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
              准备好开始你的观影之旅了吗？
            </h2>
            <p className="text-background-50/80 text-base md:text-lg mb-8 max-w-xl mx-auto">
              立即下载爱液视频App，海量高清内容等你来发现。新用户注册即享3天会员体验！
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href={downloadLinks.android.url}
                className="w-full sm:w-auto px-8 py-3.5 bg-background-50 text-primary-600 rounded-full text-base font-semibold hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              >
                <i className="ri-android-line text-lg"></i>
                Android 下载
              </a>
              <a
                href={downloadLinks.ios.url}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-600 text-background-50 border border-background-50/30 rounded-full text-base font-semibold hover:bg-primary-700 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              >
                <i className="ri-apple-line text-lg"></i>
                iOS 下载
              </a>
            </div>
            <p className="text-background-50/60 text-sm mt-6">
              当前版本 {downloadLinks.android.version} · 安全下载 · 无病毒
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}